import '@/scss/pages/blog/blog.scss';
import {loadMorePosts} from "@/js/pages/blog/components/loadMorePosts";
import {newProductsSwiper} from "@/js/pages/home/components/newProductsSwiper";

loadMorePosts();
newProductsSwiper();